<template>
  <div class="pa-4">
    <div>
      <div>{{ index }}. {{ question.title }}</div>
      <div style="font-size: 12px">{{ question.countReply || 0 }} câu trả lời</div>
    </div>
    <apexchart v-if="!loading" width="400" type="bar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      series: [
        {
          data: []
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      }
    }
  },
  mounted() {
    const labels = this.question.answers.map(answer => answer.title)
    const series = this.question.answers.map(answer => answer.countChoice)

    this.chartOptions.xaxis.categories = labels
    this.series[0].data = series
    this.loading = false
  }
}
</script>

<style></style>
